// 给每个小题的选项设置answer字段，true表示正确答案，false表示错误答案，null表示未设置答案
import { smallQuestionTypeEnum } from '@/views/PaperCollect/enum'
import lodash from 'lodash'
import { chooseSmallQuestionTypeList } from '@/views/PopQuiz/enum'

/**
 * 为小列表中的选项类型列表设置答案状态
 * 遍历小列表，根据每个小项的answer值来设置其选项类型列表中每个选项的answer属性
 * 如果小项的answer为null，则所有选项的answer设为null；否则根据选项id是否在answer数组中来设置布尔值
 *
 * @param {Array} smallList - 包含小项的数组，每个小项应包含optionsTypeList和answer属性
 * @returns {Array} 返回处理后的smallList数组，其中每个小项的optionsTypeList中的选项都已设置answer属性
 */
export function setAnswerForSmallList(smallList) {
  return smallList.map(small => {
    if (chooseSmallQuestionTypeList.includes(small.type)) {
      // 为每个小项的选项类型列表设置答案状态
      small.optionsTypeList = small.optionsTypeList.map(option => {
        if (small.answer === null) {
          option.answer = null
        } else {
          option.answer = small.answer.includes(option.id)
        }
        return option
      })
    }

    return small
  })
}

// 根据正确率获取色值
export function getColorByScore(score) {
  if (typeof score !== 'number') return {}
  if (score >= 0 && score < 60) {
    return {
      color: '#FF3C30',
      scoreTagBg: '#FFEBEA',
      bgColor: 'rgba(255,60,48,0.1)',
      capsuleBgColor: 'linear-gradient( 90deg, #FF3C30 0%, #FF7B72 100%)'
    }
  } else if (score >= 60 && score < 85) {
    return {
      color: '#FFA516',
      scoreTagBg: '#FFF6E7',
      bgColor: 'rgba(255,165,22,0.1)',
      capsuleBgColor: 'linear-gradient( 270deg, #FFD131 0%, #FFA516 100%)'
    }
  } else if (score >= 85 && score <= 100) {
    return {
      color: '#1DC060',
      scoreTagBg: '#E8F9EF',
      bgColor: 'rgba(29,192,96,0.1)',
      capsuleBgColor: 'linear-gradient( 270deg, #41EA86 0%, #1DC060 100%)'
    }
  }
  return {}
}
